import { render, staticRenderFns } from "./searchActivity.vue?vue&type=template&id=1be502b9&scoped=true&"
import script from "./searchActivity.vue?vue&type=script&lang=js&"
export * from "./searchActivity.vue?vue&type=script&lang=js&"
import style0 from "./searchActivity.vue?vue&type=style&index=0&id=1be502b9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be502b9",
  null
  
)

export default component.exports